import { createMigration } from './utils';

const ASSET_TYPES_TO_CLEAR_OBJECT_ANIMATIONS = ['RectangleAsset', 'GradientAsset', 'CircleAsset'];

export const migrationTo9_228 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            map.get('children', []).forEach((_child, cIndex: number) => {
                const path = ['children', cIndex];
                const asset = map.getIn(path) as any;
                if (!asset) {
                    return;
                }
                const classType = asset.get('classType');
                if (!ASSET_TYPES_TO_CLEAR_OBJECT_ANIMATIONS.includes(classType)) {
                    return;
                }
                // Remove objectAnimation array if it exists
                if (asset.has('objectAnimation')) {
                    map.setIn([...path, 'objectAnimation'], []);
                }
            });
        });
    },
});
